import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "table-density-2",
  "use": "table-density-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"table-density-2\"><path d=\"M21 19H3v2h18v-2ZM21 13.67H3v2h18v-2ZM21 8.33H3v2h18v-2ZM21 3H3v2h18V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol